<div class="chat-search-wrapper" [class.disabled]="disabled" [class.pip-mode]="pipMode" [attr.aria-disabled]="disabled" role="group">

  <div class="top-row">
    <textarea #textarea class="chat-search-input" rows="1" [disabled]="disabled" [attr.placeholder]="label"
    [attr.aria-label]="label" role="searchbox" (input)="onInput($event)" (keydown)="onKeydown($event)"></textarea>
    @if (!streaming) {
      <sh-icon id="chat-search-icon-send-message" icon="send-message" button size="s" (click)="emitSearch()" [disabled]="disabled"
      [attr.aria-label]="'chatbot.search.sendAriaLabel' | transloco"></sh-icon>
    }
    @if (streaming) {
      <sh-icon id="chat-search-icon-stop-chat" icon="stop" button size="s" class="chat-search-stop" (click)="emitInterrupt()" [disabled]="!streaming"
      [attr.aria-label]="'chatbot.search.stopAriaLabel' | transloco"></sh-icon>
    }

  </div>

  @if (!pipMode) {
    <div class="bottom-row">
      <ng-content></ng-content>
    </div>
  }




</div>